import axios from "../../utils/axios";

export async function getRelatedPosts(id = null, tags = []) {
  if (!id && tags?.length === 0) {
    const response = await axios.get("/blogs");
    return response?.data;
  }

  const queryString = tags.map((tag) => `tags_like=${tag}`).join("&");
  const response = await axios.get(`/blogs?${queryString}&id_ne=${id}`);

  return response?.data;
}
